package com.timacookies.pages.de

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initPrivacyPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("de/privacy.md", FrontMatterElement.Builder { addScalar("title", "Datenschutzerklärung"); }))
}

@Page("/de/privacy")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun PrivacyPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("datenschutzerklärung") }) {
        org.jetbrains.compose.web.dom.Text("Datenschutzerklärung")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("1-wer-wir-sind") }) {
        org.jetbrains.compose.web.dom.Text("1. Wer wir sind")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Diese Website wird von Fatima Jovic – Tima Cookies mit Sitz in der Schweiz betrieben. Bei Fragen zum Datenschutz können Sie uns unter folgender Adresse kontaktieren: ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("E-Mail:")
        }
        org.jetbrains.compose.web.dom.Text(" ")
        com.varabyte.kobweb.silk.components.navigation.Link("mailto:timacookies.ch@gmail.com") {
            org.jetbrains.compose.web.dom.Text("timacookies.ch@gmail.com")
        }
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("2-einleitung") }) {
        org.jetbrains.compose.web.dom.Text("2. Einleitung")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Wir setzen uns für den Schutz Ihrer persönlichen Daten und die Achtung Ihrer Privatsphäre ein. Diese Datenschutzerklärung erläutert, wie wir mit Ihren Informationen gemäss den geltenden Schweizer Datenschutzgesetzen, insbesondere dem Bundesgesetz über den Datenschutz (DSG), umgehen.")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("3-daten-die-wir-sammeln") }) {
        org.jetbrains.compose.web.dom.Text("3. Daten, die wir sammeln")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Diese Website sammelt nicht aktiv personenbezogene Daten. Wenn Sie die Website besuchen, können jedoch bestimmte technische Daten automatisch von Ihrem Browser oder Hosting-Provider erfasst werden, einschliesslich:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("IP-Adresse")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Browser-Typ und -Version")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Datum und Uhrzeit des Zugriffs")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Betriebssystem")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Diese Daten werden nicht dazu verwendet, Personen zu identifizieren.")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("4-cookies") }) {
        org.jetbrains.compose.web.dom.Text("4. Cookies")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Diese Website verwendet keine Tracking- oder Marketing-Cookies. Alle verwendeten Cookies sind für den technischen Betrieb und die Sicherheit der Website zwingend erforderlich.")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("5-zweck-der-datenverarbeitung") }) {
        org.jetbrains.compose.web.dom.Text("5. Zweck der Datenverarbeitung")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Alle automatisch erhobenen Daten werden nur verwendet für:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Sicherstellung des ordnungsgemässen Funktionierens der Website")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Aufrechterhaltung von Sicherheit und Stabilität")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Erkennung und Verhinderung von Missbrauch")
        }
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("6-rechtsgrundlage") }) {
        org.jetbrains.compose.web.dom.Text("6. Rechtsgrundlage")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Die Datenverarbeitung erfolgt in Übereinstimmung mit dem Bundesgesetz über den Datenschutz (DSG). Soweit anwendbar, basiert die Verarbeitung auf unserem berechtigten Interesse an der Aufrechterhaltung einer sicheren und funktionalen Website.")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("7-weitergabe-von-daten") }) {
        org.jetbrains.compose.web.dom.Text("7. Weitergabe von Daten")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Wir verkaufen oder teilen Ihre persönlichen Daten nicht mit Dritten. Daten können von technischen Dienstleistern (wie z.B. Hosting-Providern) ausschliesslich zum Zweck des Betriebs der Website verarbeitet werden.")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("8-aufbewahrung-von-daten") }) {
        org.jetbrains.compose.web.dom.Text("8. Aufbewahrung von Daten")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Technische Daten werden nur so lange aufbewahrt, wie es zur Gewährleistung der Sicherheit und des ordnungsgemässen Funktionierens der Website erforderlich ist.")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("9-ihre-rechte") }) {
        org.jetbrains.compose.web.dom.Text("9. Ihre Rechte")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Nach dem Bundesgesetz über den Datenschutz (DSG) haben Sie das Recht:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Auskunft über Ihre personenbezogenen Daten zu verlangen")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Die Berichtigung unrichtiger Daten zu verlangen")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Die Löschung Ihrer Daten zu verlangen, sofern anwendbar")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Um Ihre Rechte auszuüben, kontaktieren Sie uns bitte unter den oben genannten Kontaktdaten.")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("10-änderungen-an-dieser-richtlinie") }) {
        org.jetbrains.compose.web.dom.Text("10. Änderungen an dieser Richtlinie")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Wir können diese Datenschutzerklärung von Zeit zu Zeit aktualisieren. Alle Änderungen werden auf dieser Seite veröffentlicht.")
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.H2(attrs = { id("impressum-legal-notice") }) {
        org.jetbrains.compose.web.dom.Text("Impressum / Legal Notice")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Inhaberin der Website")
        }
        org.jetbrains.compose.web.dom.Text(" Fatima Jovic – Tima Cookies Rikonerstrasse 22 8307, Effretikon Schweiz")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Kontakt")
        }
        org.jetbrains.compose.web.dom.Text(" E-Mail: ")
        com.varabyte.kobweb.silk.components.navigation.Link("mailto:timacookies.ch@gmail.com") {
            org.jetbrains.compose.web.dom.Text("timacookies.ch@gmail.com")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Haftungsausschluss")
        }
        org.jetbrains.compose.web.dom.Text(" Die Inhalte dieser Website wurden mit Sorgfalt erstellt. Wir übernehmen jedoch keine Gewähr für die Richtigkeit, Vollständigkeit oder Zuverlässigkeit der Inhalte. Wir sind nicht verantwortlich für die Inhalte externer Websites, die von dieser Seite aus verlinkt sind.")
    }
}
